import { ButtonTheme } from '@ui-components/PlayButton';
import { SearchPageHits } from 'app/graphql/__generated__/types/contento';
import { OnItemImpressionType } from 'app/utils/useTrackImpression';
import React from 'react';
import {
    Heading,
    SearchSuggestionList,
    SearchSuggestionListItem,
    ShowAllListItem,
    ShowSearchResultButton,
    SuggestionsPopOver,
} from './AutoCompleteResult.styles';
import { getId, value } from './helpers';
import PopOverLink from './PopOverLink';

type AutoCompleteButtonTypes = {
    searchTerm: string;
    onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const AutoCompleteButton = ({ searchTerm, onClick }: AutoCompleteButtonTypes) => (
    <ShowAllListItem>
        <ShowSearchResultButton
            to="/sok"
            query={{ q: searchTerm }}
            onClick={onClick}
            data-rt-spec="search-result-btn"
            theme={ButtonTheme.DARK}
        >
            <span className="play_search-suggestions__show-all-icon" aria-hidden="true" />
            Visa alla sökträffar
        </ShowSearchResultButton>
    </ShowAllListItem>
);

type PopOverProps = {
    result: SearchPageHits;
    suggestionClick: (value: string) => void;
    term: string;
    onAllMatchesClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onItemImpression: OnItemImpressionType;
};

const PopOver = ({ result, suggestionClick, term, onAllMatchesClick, onItemImpression }: PopOverProps) => (
    <SuggestionsPopOver portal={false} data-state="suggesting">
        {result.name && <Heading>{result.name}</Heading>}
        <SearchSuggestionList key={JSON.stringify(result.hits)}>
            {result.hits.map((item, index) => (
                <SearchSuggestionListItem key={getId(item)} value={value(item)}>
                    <PopOverLink
                        item={item}
                        suggestionClick={suggestionClick}
                        itemPosition={index}
                        onItemImpression={onItemImpression}
                    />
                </SearchSuggestionListItem>
            ))}
            {term !== '' && <AutoCompleteButton searchTerm={term} onClick={onAllMatchesClick} />}
        </SearchSuggestionList>
    </SuggestionsPopOver>
);

export default PopOver;
